export class UserLoginModel {
  constructor(
    public token: string,
    public expires_in: string,
    public username: string,
    public orgId: string,
    public isVerifyCode: boolean
  ) { }
}
